import { Container, Heading, Text, VStack, Box, UnorderedList, ListItem, useColorModeValue } from '@chakra-ui/react'

export default function Privacy() {
  return (
    <Box minH="100vh" w="100vw" bg={useColorModeValue('gray.50', 'gray.900')}>
      <Container 
        maxW={{ base: 'container.sm', md: 'container.md', lg: 'container.lg' }}
        py={{ base: 8, md: 12 }}
        px={{ base: 4, md: 8 }}
      >
        <VStack spacing={{ base: 6, md: 8 }} align="stretch" w="full">
          <VStack spacing={2} textAlign="center" w="full">
            <Heading 
              as="h1" 
              size={{ base: 'lg', md: 'xl' }}
            >
              Privacy Policy
            </Heading>
          </VStack>

          <Text fontSize={{ base: 'sm', md: 'md' }} textAlign="center">
            At VehicleLogi, we take your privacy seriously. This privacy policy describes how we collect,
            use, and protect your personal information when you use our vehicle expense tracking service.
          </Text>

          <VStack spacing={8} align="stretch">
            <Box>
              <Heading as="h2" size={{ base: 'md', md: 'lg' }} mb={3}>Information We Collect</Heading>
              <Text fontSize={{ base: 'sm', md: 'md' }} mb={3}>
                We collect information that you provide directly to us when using VehicleLogi:
              </Text>
              <UnorderedList 
                spacing={2} 
                pl={4}
                fontSize={{ base: 'sm', md: 'md' }}
              >
                <ListItem>Account information (name, email) through Google Sign-In</ListItem>
                <ListItem>Vehicle details and specifications</ListItem>
                <ListItem>Expense records and receipts</ListItem>
                <ListItem>Usage data and preferences</ListItem>
              </UnorderedList>
            </Box>

            <Box>
              <Heading as="h2" size={{ base: 'md', md: 'lg' }} mb={3}>Google Authentication</Heading>
              <Text fontSize={{ base: 'sm', md: 'md' }} mb={3}>
                We use Google Sign-In for authentication. When you sign in using Google:
              </Text>
              <UnorderedList 
                spacing={2} 
                pl={4}
                fontSize={{ base: 'sm', md: 'md' }}
              >
                <ListItem>We receive your Google profile information (name, email, profile picture)</ListItem>
                <ListItem>We do not receive your Google password or other sensitive account details</ListItem>
                <ListItem>Your Google account credentials are handled securely by Google</ListItem>
                <ListItem>You can revoke our access to your Google account at any time through your Google Account settings</ListItem>
              </UnorderedList>
            </Box>

            <Box>
              <Heading as="h2" size={{ base: 'md', md: 'lg' }} mb={3}>How We Use Your Information</Heading>
              <UnorderedList 
                spacing={2} 
                pl={4}
                fontSize={{ base: 'sm', md: 'md' }}
              >
                <ListItem>To provide and maintain our service</ListItem>
                <ListItem>To authenticate your identity and manage your account</ListItem>
                <ListItem>To store and process your vehicle expense records</ListItem>
                <ListItem>To generate reports and analytics about your expenses</ListItem>
                <ListItem>To improve and optimize our service</ListItem>
                <ListItem>To communicate with you about service updates or responses to your inquiries</ListItem>
              </UnorderedList>
            </Box>

            <Box>
              <Heading as="h2" size={{ base: 'md', md: 'lg' }} mb={3}>Data Storage and Security</Heading>
              <Text fontSize={{ base: 'sm', md: 'md' }} mb={3}>
                We store your data securely in the cloud using industry-standard security measures:
              </Text>
              <UnorderedList 
                spacing={2} 
                pl={4}
                fontSize={{ base: 'sm', md: 'md' }}
              >
                <ListItem>All data is encrypted in transit and at rest</ListItem>
                <ListItem>We use Google Cloud Platform for secure data storage</ListItem>
                <ListItem>Regular security audits and updates are performed</ListItem>
                <ListItem>Access to your data is strictly controlled and monitored</ListItem>
              </UnorderedList>
            </Box>

            <Box>
              <Heading as="h2" size={{ base: 'md', md: 'lg' }} mb={3}>Your Rights</Heading>
              <Text fontSize={{ base: 'sm', md: 'md' }} mb={3}>
                You have the following rights regarding your personal information:
              </Text>
              <UnorderedList 
                spacing={2} 
                pl={4}
                fontSize={{ base: 'sm', md: 'md' }}
              >
                <ListItem>Access your personal data</ListItem>
                <ListItem>Correct inaccurate data</ListItem>
                <ListItem>Request deletion of your data</ListItem>
                <ListItem>Export your data in a common format</ListItem>
                <ListItem>Opt-out of marketing communications</ListItem>
              </UnorderedList>
            </Box>

            <Box>
              <Heading as="h2" size={{ base: 'md', md: 'lg' }} mb={3}>Changes to This Policy</Heading>
              <Text fontSize={{ base: 'sm', md: 'md' }}>
                We may update this privacy policy from time to time. We will notify you of any changes by posting the new privacy policy on this page and updating the "Last updated" date.
              </Text>
            </Box>

            <Box>
              <Heading as="h2" size={{ base: 'md', md: 'lg' }} mb={3}>Contact Us</Heading>
              <Text fontSize={{ base: 'sm', md: 'md' }}>
                If you have any questions about this privacy policy or our treatment of your personal information, please contact us at privacy@vehiclelogi.com.
              </Text>
            </Box>
          </VStack>
          <Text fontSize="sm" color="gray.500" textAlign="center" mt={4}>
            Last Updated: January 18, 2025
          </Text>
        </VStack>
      </Container>
    </Box>
  )
} 